import VisibleComponent from '../VisibleComponent'
import {fetchDataByAjax} from '../../../../common/util'
import './index.less'
import Roll from "../../Roll1";

const template = `
                <div class="mtg-single-recommend-box">
                  <div class="info-icon-box iconBox"></div>
                  <div class="roll-wrap adBox">
                      <div class="info-other outerBox-320-50">
                          <div class="info-wrap innerBox-320-50">
                              <div class="info-box">
                                  <div class="info">
                                      <div class="info-title-rate">
                                          <div class="info-title infoTitle line-clamp1"></div>
                                          <div class="info-other-rate">
                                              <div class="star-number starNumber"></div>
                                              <div class="star-evaluate starBox">
                                                  <span class="star star-10"></span>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="roll-wrap descBox">
                                          <div class="info-desc-box outerBox-320-250">
                                              <div class="info-desc innerBox-320-250">
                                                  <div class="info-other-rate">
                                                      <div class="star-number starNumber"></div>
                                                      <div class="star-evaluate starBox">
                                                          <span class="star star-10"></span>
                                                      </div>
                                                  </div>
                                                  <div class="info-desc-text infoDesc infoDescText"></div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="info-install cta"></div>
                              </div>
                              <div class="info-desc-box">
                                  <div class="info-desc line-clamp2 infoDesc"></div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
`

/**
 * MoreOffer类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class BannerMoreOffer extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.mofRes = {}
        this.offerList = []
        // 定义默认配置
        const defaultOpts = {
            offerData: [], // 猜你喜欢offer数据列表
            url: "", // 猜你喜欢请求url
            minLength: 1, // 最少请求猜你喜欢的个数
            maxLength: 1, // 最多请求猜你喜欢个数
            onOfferClick: "", // offer点击事件
            onLoadSuccess: [], // 加载成功后执行函数列表
            onLoadFailed: [], // 加载失败后执行函数列表
        }
        // 传入的配置覆盖掉默认配置
        this.opts = Object.assign(defaultOpts, options)
        console.log("more offer options", this.opts)
        this.init(this.opts)
    }

    init(opts) {
        super.init()

        Array.isArray(this.opts.onLoadSuccess) && this.opts.onLoadSuccess.forEach(cb => this.onLoadSuccess(cb))

        Array.isArray(this.opts.onLoadFailed) && this.opts.onLoadFailed.forEach(cb => this.onLoadFailed(cb))
        const minLength = this.opts.minLength || 1
        if (opts['url']) {
            fetchDataByAjax('get', opts['url'], '', (response) => {
                let res
                // 将返回值解析为 object
                try {
                    res = JSON.parse(response)
                } catch (e) {
                    console.error('res parse failed: ', e)
                }
                this.mofRes = res

                // 如果 response 中返回的 campaign 列表大于 0,
                // 就会认为数据返回正常, 开始走后续的渲染流程
                if (res.status === 1
                    && res.data
                    && res.data.ads
                    && res.data.ads.length >= minLength
                ) {
                    this.onlyImpression = res.data.only_impression_url
                    this.offerList = res.data.ads
                    console.log('Ajax-get Mof data success!', this.offerList)

                    if (this.offerList.length > 0) {
                        this.iconStatus = new Array(minLength)
                        this.iconStatus.fill(true)
                        console.log('icon Status init length: ', this.iconStatus && this.iconStatus.length)
                    }

                    this.eventManager.fireEvent('loadSuccess')
                } else {
                    console.error('EC_MOF: fetch Recommend Data failed: ', res)
                    this.eventManager.fireEvent('loadFailed')
                }
            }, (err) => {
                console.error('Ajax request failed!', err)
                this.eventManager.fireEvent('loadFailed')
            })
        } else if (opts['offerData']) {
            this.offerList = opts['offerData']
            console.log('Get mof data success!', this.offerList)

            if (this.offerList.length > 0) {
                this.iconStatus = new Array(minLength)
                this.iconStatus.fill(true)
                console.log('icon Status init length: ', this.iconStatus && this.iconStatus.length)
            }

            this.eventManager.fireEvent('loadSuccess')
        } else {
            console.error('EC_MOF: Do not have enough info for init!')
            this.eventManager.fireEvent('loadFailed')
        }
    }

    bindVisibleComponentEvent() {
        super.bindVisibleComponentEvent()
        this.mtgRecommendBox = this.element
        // offer列表绑定点击事件
        this.mtgRecommendBox.addEventListener('click', (event) => {
            console.log('more offer clicked')
            let campaign = this.offerList[0]
            this.eventManager.fireEvent('offerClick', {event, campaign})
        }, false)
        // offer列表资源载入错误
        this.element.addEventListener('error', (event) => {
            console.log('页面资源载入错误', event)
            this.eventManager.fireEvent('error', event)
        }, false)
    }

    render() {
        console.log("###banner moreoffer render")
        this.recommendTitle = this.element.getElementsByClassName("infoTitle")
        this.recommendIcon = this.element.getElementsByClassName("iconBox")
        this.recommendDesc = this.element.getElementsByClassName("infoDesc")
        this.recommendRating = this.element.getElementsByClassName("starNumber")
        this.recommendCta = this.element.getElementsByClassName("cta")
        this.recommendStarBox = this.element.getElementsByClassName("starBox")
        let recommemdList = this.offerList.slice(0, this.opts.maxLength)
        console.log("###banner moreoffer recommemdList", recommemdList)
        const itemIconUrl = recommemdList[0].icon_url;
        const itemTitle = recommemdList[0].title;
        const itemDesc = recommemdList[0].desc;
        const itemRating = recommemdList[0].rating;
        const itemCtatext = recommemdList[0].ctatext;
        // 插入title
        this.insertInnerHtml(this.recommendTitle, itemTitle)
        // 插入描述
        this.insertInnerHtml(this.recommendDesc, itemDesc)
        // 插入cta（下载按钮）文字
        this.insertInnerHtml(this.recommendCta, itemCtatext)
        // 插入评分
        this.insertInnerHtml(this.recommendRating, itemRating)
        // 插入icon
        this.insertImg(this.recommendIcon, itemIconUrl)
        // 设置星星评级
        this.insertStar(this.recommendStarBox, itemRating);
    }

    // 初始化滚动
    initRoll() {
        console.log("#初始化滚动")
        const bodyWidth = window.innerWidth;
        const bodyHeight = window.innerHeight;
        window.ratio = bodyWidth / bodyHeight;
        const v1 = ((320 / 250) + (320 / 90)) / 2;
        const v2 = ((320 / 90) + (320 / 50)) / 2;
        const v3 = ((320 / 50) + (728 / 90)) / 2;
        if (ratio < v1) {   //  适配 320*250 设计图样式
            this.element.getElementsByClassName("infoDescText")[0].classList.add('line-clamp2')
            window.roll1 = null;
            window.roll1 = new Roll({
                outerBox: this.element.getElementsByClassName("outerBox-320-250")[0],
                innerBox: this.element.getElementsByClassName("innerBox-320-250")[0],
                time: '2000',
                step: this.element.getElementsByClassName("descBox")[0].offsetHeight,
                direction: "top"
            });
            roll1.startRoll();
        } else if (ratio > v1 && ratio < v2) {  //  适配 320*90  设计图样式
            if (this.element.getElementsByClassName("infoDescText")[0].classList.contains("line-clamp2")) {
                this.element.getElementsByClassName("infoDescText")[0].classList.remove('line-clamp2')
            }
            window.roll2 = null;
            window.roll2 = new Roll({
                outerBox: this.element.getElementsByClassName("outerBox-320-250")[0],
                innerBox: this.element.getElementsByClassName("innerBox-320-250")[0],
                time: '2000',
                step: this.element.getElementsByClassName("descBox")[0].offsetHeight,
                direction: "top"
            });
            roll2.startRoll()
        } else if (ratio > v2 && ratio < v3) {  //  适配 320*50 设计图样式
            if (this.element.getElementsByClassName("infoDescText")[0].classList.contains("line-clamp2")) {
                this.element.getElementsByClassName("infoDescText")[0].classList.remove('line-clamp2')
            }
            window.roll3 = null;
            window.roll3 = new Roll({
                outerBox: this.element.getElementsByClassName("outerBox-320-50")[0],
                innerBox: this.element.getElementsByClassName("innerBox-320-50")[0],
                time: '2000',
                step: this.element.getElementsByClassName("adBox")[0].offsetHeight,
                direction: "top"
            });
            roll3.startRoll()
        } else if (ratio > v3) {    //  适配 728*90 设计图样式
            if (this.element.getElementsByClassName("infoDescText")[0].classList.contains("line-clamp2")) {
                this.element.getElementsByClassName("infoDescText")[0].classList.remove('line-clamp2')
            }
            window.roll4 = null;
            window.roll4 = new Roll({
                outerBox: this.element.getElementsByClassName("outerBox-320-250")[0],
                innerBox: this.element.getElementsByClassName("innerBox-320-250")[0],
                time: '2000',
                step: this.element.getElementsByClassName("descBox")[0].offsetHeight,
                direction: "top"
            });
            roll4.startRoll()
        }
    }

    // 插入星星评级
    insertStar(elem, rate) {
        let fullStar = 0;
        let halfStar = 0;
        let curStar = 0;
        if (parseFloat(rate) > 5 || parseFloat(rate) < 1) {
            curStar = 5.0;
        } else {
            fullStar = parseInt(rate);
            halfStar = Math.ceil((parseFloat(rate) % 1) / 0.5);
            curStar = fullStar + 0.5 * halfStar;
        }
        let starBoxArr = Array.from(elem);
        for (let i of starBoxArr) {
            i.getElementsByTagName("span")[0].className = `star star-${curStar * 2}`;
        }
    }

    // 插入图片
    insertImg(elem, url) {
        let elemArr = Array.from(elem);
        // 兼容传入id的情况
        if (elemArr.length === 0) {
            elemArr.push(elem)
        }
        for (let i of elemArr) {
            if (url) {
                let img = new Image();
                img.src = url;
                i.appendChild(img);
            } else {
                i.classList.add("hide")
            }
        }
    }

    // 插入html
    insertInnerHtml(elem, content) {
        let elemArr = Array.from(elem)
        if (content) {
            if (typeof content === "number") {
                content = content.toFixed(1)
            }
            for (let i of elemArr) {
                i.innerHTML = content;
            }
        }
    }

    /**
     * 将当前组件添加到指定组件上
     * @param params
     * @returns {*|Promise<any>}
     */
    appendTo(target) {
        super.appendTo(target)
        // 滚动函数必须在appendTo 插入页面中后再调用，否则获取不到宽高
        setTimeout(() => {
            this.initRoll();
        }, 1000)
        // 猜你喜欢插入到页面中的时候，给 body 增加"open-more-offer" 样式，以适配猜你喜欢展示后的样式
        document.body.classList.add('open-more-offer')
    }

    getMofRes() {
        return this.mofRes
    }

    checkIconStatus(start, end) {
        console.log("checkIconStatus start", start)
        console.log("checkIconStatus end", end)
        for (let i = start; i < end; ++i) {
            console.log(Date.now(), 'check Icon Item Status: ', this.iconStatus[i])
            if (this.iconStatus && this.iconStatus[i] === true) {
                // 如果当前 icon 加载成功则暂时不做任何处理
            } else {
                // 如果 "more offer 还未初始化" OR "当前 icon 还没有加载成功" OR "当前icon 加载失败"，则直接返回 false
                return false
            }
        }
        // 如果所有 icon 通过检查，则返回 true
        return true
    }

    onError(cb) {
        'function' === typeof cb && this.eventManager.addEventListener('error', cb)
    }

    onScroll(cb) {
        'function' === typeof cb && this.eventManager.addEventListener('scroll', cb)
    }

    onLoadFailed(cb) {
        'function' === typeof cb && this.eventManager.addEventListener('loadFailed', cb)
    }

    onLoadSuccess(cb) {
        'function' === typeof cb && this.eventManager.addEventListener('loadSuccess', cb)
    }

    onOfferClick(cb) {
        'function' === typeof cb && this.eventManager.addEventListener('offerClick', cb)
    }
}

export default BannerMoreOffer